import React  from "react";
import { useParams } from 'react-router-dom';
import SalaryDeductionForm from "./components/SalaryDeductionForm";
import SalaryDeductionHistory from "./components/SalaryDeductionHistory";

const ViewSalaryDeduction = () => {
	const { deductionId } = useParams();
    
	return (
	    <div>
	    	<div className="mt-5 grid h-full grid-cols-1 gap-4">
	      		<SalaryDeductionForm recordId={deductionId} mode="view"/>

				<SalaryDeductionHistory/>
	      	</div>
	    </div>
    );
};

export default ViewSalaryDeduction;